import axios from 'axios'

const actions = {
  fetch(store, { url, mutationTypes, options }) {
    store.commit(mutationTypes.PENDING, options)
    return axios(url, options)
      .then(response => {
        const data = response.data.results || response.data
        if (response.data.count) {
          store.commit(mutationTypes.SUCCESS, { data, count: response.data.count })
        } else {
          store.commit(mutationTypes.SUCCESS, { data, options })
        }
        return data
      })
      .catch(error => {
        store.commit(mutationTypes.FAILURE, options)
        return Promise.reject(error.response)
      })
  },
  post(store, { url, mutationTypes, data, options }) {
    store.commit(mutationTypes.PENDING)
    return axios
      .post(url, data, options)
      .then(response => {
        store.commit(mutationTypes.SUCCESS, response.data)
        return response.data
      })
      .catch(error => {
        store.commit(mutationTypes.FAILURE, error.response)
        return Promise.reject(error && error.response ? error.response : error)
      })
  },
  put(store, { url, mutationTypes, data, options }) {
    store.commit(mutationTypes.PENDING)
    return axios
      .put(url, data, options)
      .then(response => {
        store.commit(mutationTypes.SUCCESS, response.data)
        return response.data
      })
      .catch(error => {
        store.commit(mutationTypes.FAILURE, error.response)
        return Promise.reject(error.response)
      })
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/actions.js